var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-list',_vm._b({staticClass:"rounded-borders",attrs:{"padding":"","separator":"","bordered":"","dense":_vm.$q.screen.gt.sm}},'q-list',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }